import { useRef } from "react";
import CsdBenefits from "../Components/CSD/csd-benefits";
import CsdContact from "../Components/CSD/csd-contact";
import CsdHeadSection from "../Components/CSD/csd-head-section";
import CsdProcess from "../Components/CSD/csd-process";
import WhyChooseCsd from "../Components/CSD/why-choose-csd";
import MainLayout from "../layout/main-layout";
import MetaTags from "../utils/meta-tags";

function CustomSoftwareDevelopment() {
  const contactRef = useRef<HTMLDivElement>(null);

  const handleScrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <MetaTags
        title="Custom Software Development Company | Tailored Business Solutions | SoftCoding Solutions"
        description="We build custom software applications that solve real-world business challenges. From web platforms to enterprise tools, we deliver scalable and secure software built to fit your unique goals."
        canonical="https://softcodingsolutions.com/custom-software-development-company"
        og={{
          title: "Custom Software Development Services | SoftCoding Solutions",
          description:
            "Partner with us to design and build custom software that fits your exact business requirements. Expert teams in Ruby on Rails, React, .NET, and more.",
          url: "https://softcodingsolutions.com/custom-software-development-company",
          type: "website",
          site_name: "SoftCoding Solutions",
          image:
            "https://softcodingsolutions.com/static/media/logo%20company.23b84ead7179e68dfe2f.png",
          imageWidth: "1200",
          imageHeight: "630",
        }}
      />
      <MainLayout>
        <CsdHeadSection onScroll={handleScrollToContact} />
        <CsdBenefits />
        <CsdProcess />
        <WhyChooseCsd />
        <CsdContact contactRef={contactRef} />
      </MainLayout>
    </div>
  );
}

export default CustomSoftwareDevelopment;
